import * as React from 'react'
import styled, { css } from 'styled-components'

import ActionButton from '../../ui/ActionButton/ActionButton'
import Avatar from '../../ui/Avatar/Avatar'
import LoadingBase from '../../loading/LoadingBase/LoadingBase'

import MaleEating from '../../../assets/img/male-eating.svg'
import ReferralImage from '../../../assets/img/referral.svg'

import media from '../../../services/generateMediaQueries'
import dateFormat from '../../../services/data/dateFormat'
import numberFormat from '../../../services/data/numberFormat'

let VARIANT_SMALL = false
let VARIANT_LITE = false

const RewardsSection = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0 30px 45px -10px rgba(85,69,13,0.2);
  border-radius: var(--border-radius-card);
  padding: 2.5rem;
  width: 100%;
  max-width: 475px;
  min-height: 360px;
  overflow: hidden;

  ${() =>
    VARIANT_SMALL &&
    css`
      padding: 2rem 1.875rem;
      margin: 0 !important;
      min-height: 80px;
      height: ${props =>
        props.advanceAccount && props.advanceAccount.advanced
          ? '287px'
          : '261px'};
      box-shadow: unset;
      border: 1px solid #ebebeb;
    `}

  ${() =>
    VARIANT_LITE &&
    css`
      background: rgba(255, 255, 255, 0.95);
      box-shadow: var(--box-shadow);
      width: unset;
      padding: 0.75rem 1.5rem;
      max-width: unset;
      min-height: 80px;
      flex: 0 0 auto;
      flex-direction: row;
      align-items: center;
    `}

  ${media.lessThan('medium')`
    max-width: unset;
    min-height: 80px;
  `}

  &:before {
    content: '';
    /* position: absolute; */
    background: url('${props =>
      props.advanceAccount && props.advanceAccount.advanced
        ? ReferralImage
        : MaleEating}');
    top: 0;
    right: ${props =>
      props.advanceAccount && props.advanceAccount.advanced ? '-26px' : '0'};
    width: 151px;
    height: 198px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 40px -23px;

    ${() =>
      VARIANT_SMALL &&
      css`
        width: 151px;
        height: 198px;
        background-position: 31px -18px;
      `}

      ${() =>
        VARIANT_LITE &&
        css`
          display: none;
        `}

    ${media.lessThan('medium')`
      width: 151px;
      height: 198px;
      background-position: 40px -23px;
    `}

    ${props =>
      props.advanceAccount &&
      css`
        width: 141px;
        height: 169px;
        background-position: 0 -15px;
      `}
  }
`

const RewardsHeader = styled.h1`
  color: var(--color-fg);
  font-size: 1.5rem;
  margin: 0;
  margin-bottom: 1rem;

  ${() =>
    VARIANT_SMALL &&
    css`
      font-size: 1.25rem;
      line-height: 1.4375rem;
      font-weight: var(--font-weight-bold);
      max-width: 159px;
    `}

  ${media.lessThan('medium')`
    font-size: 1.25rem;
    margin-bottom: 0.5rem;
  `}
`

const RewardsDate = styled.p`
  color: var(--color-fg-light);
  font-size: 0.75rem;
  margin: 0;
  margin-bottom: 1.2rem;
  letter-spacing: var(--letter-spacing);
  white-space: nowrap;
  width: 0;

  ${() =>
    VARIANT_LITE &&
    css`
      margin-bottom: 0;
    `}

  ${media.lessThan('small')`
      font-size: 0.625rem;
    `}
`

const Points = styled.p`
  font-size: 2.25rem;
  font-weight: var(--font-weight-bold);
  line-height: 1;
  color: var(--color-primary);
  margin: 0;

  ${() =>
    VARIANT_LITE &&
    css`
      ${media.lessThan('small')`
      font-size: 2rem;
    `}
    `}
`

const PointsLabel = styled.p`
  font-size: 0.875rem;
  color: var(--color-primary);
  letter-spacing: var(--letter-spacing-wide);
  font-weight: var(--font-weight-bold);
  text-transform: uppercase;
  margin: 0;
`

const RewardsFooter = styled.div`
  /* position: absolute; */
  width: 100%;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 2.5rem;
  font-weight: var(--font-weight-bold);

  ${() =>
    VARIANT_SMALL &&
    css`
      padding: 1.5rem;
    `}

  ${media.lessThan('medium')`
    padding: 1.5rem;
  `}
`

const Divider = styled.div`
  height: 28px;
  width: 17px;
`

const StyledPointsButton = styled(ActionButton)`
  ${() =>
    VARIANT_SMALL &&
    css`
      padding: 0 0.7rem;
      font-size: 0.75rem;
      font-weight: var(--font-weight-bold);
      letter-spacing: var(--letter-spacing-wide);
    `}

  ${media.lessThan('medium')`
    font-size: 0.75rem;
  `}
`

const BasicDescription = styled.p`
  color: var(--color-fg);
  max-width: 250px;
  font-size: 1.125rem;
  margin-top: 0;

  ${() =>
    VARIANT_SMALL &&
    css`
      font-size: 0.8125rem;
      line-height: 1.1875rem;
      max-width: 173px;
    `}
`

const FinePrint = styled.p`
  color: var(--color-fg-light);
  max-width: 250px;
  font-size: 0.7rem;
  margin-top: 8px;
`

const StyledActionButton = styled(ActionButton)`
  text-transform: unset;
  font-weight: var(--font-weight-bold);
  margin-right: auto;
`

const Error = styled.p`
  font-size: 12px;
  font-weight: var(--font-weight-bold);
  margin-bottom: 0px;
  margin-top: 0px;
  color: red;
  width: 80px;
`

const LiteImageContainer = styled.div`
  flex: 0 0 auto;
  position: relative;
  margin-right: 1rem;
  overflow: hidden;
  border-radius: 3rem;
  width: 3rem;
  height: 3rem;

  ${props =>
    props.hasBackground &&
    css`
      background: #eb826a;
      padding: 0.3rem;
    `}
`

const StyledAvatar = styled(Avatar)`
  height: 100%;
  width: 100%;
  color: #ffffff;
`

const LiteContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  position: relative !important;
  /* height: 200px !important; */
`

const LiteTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: stretch;
  /* height: 200px !important; */
`

const LitePointsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: 1rem;
  min-width: 100px;
`

const LiteTitle = styled.h3`
  color: var(--color-primary);
  text-transform: uppercase;
  margin: 0;
  line-height: 1.1;
  font-size: 1.1rem;
`

const LargeCardContent = styled.div`
  position: relative !important;
`

function PointsCard({
  accessToken,
  loyaltyPoints,
  showPointsHistory,
  showHowToEarn,
  small,
  lite,
  primaryInfo,
  advanceAccount,
  displayAddCardForm,
  loyaltyPointsError,
  setLoyaltyPoints,
  setAccountStatus,
  ...restProps
}) {
  const { avatarUrl } = primaryInfo || {}
  VARIANT_SMALL = small
  VARIANT_LITE = lite

  return (
    <RewardsSection {...restProps} advanceAccount={advanceAccount}>
      {lite ? (
        <>
          <LiteImageContainer hasBackground={!avatarUrl}>
            <StyledAvatar variant="circle" src={avatarUrl} />
          </LiteImageContainer>
          <LiteContainer>
            <LiteTitleContainer>
              <LiteTitle>Zing Points</LiteTitle>
              {advanceAccount && advanceAccount.advanced && (
                <>
                  {loyaltyPoints.updatedAt ? (
                    <RewardsDate>
                      As of {dateFormat(loyaltyPoints.updatedAt)}
                    </RewardsDate>
                  ) : (
                    <LoadingBase
                      size="small"
                      style={{
                        margin: 0,
                      }}
                    />
                  )}
                </>
              )}
            </LiteTitleContainer>

            <LitePointsContainer>
              {advanceAccount !== null ? (
                <>
                  {advanceAccount.advanced ? (
                    <>
                      {loyaltyPoints.available !== null ? (
                        <Points
                          style={{
                            fontSize:
                              loyaltyPoints.available > 99999 ? '1.5rem' : null,
                          }}
                        >
                          {loyaltyPoints &&
                            numberFormat(loyaltyPoints.available)}
                        </Points>
                      ) : (
                        <LoadingBase
                          style={{
                            margin: 0,
                          }}
                        />
                      )}
                    </>
                  ) : (
                    <StyledActionButton
                      small
                      variant="primary"
                      onClick={displayAddCardForm}
                    >
                      Link card now
                    </StyledActionButton>
                  )}
                </>
              ) : (
                <LoadingBase
                  style={{
                    margin: 0,
                  }}
                />
              )}
            </LitePointsContainer>
          </LiteContainer>
        </>
      ) : (
        <LargeCardContent>
          <RewardsHeader>My Zing Rewards</RewardsHeader>
          {advanceAccount && advanceAccount.advanced ? (
            <>
              <RewardsDate>
                As of {loyaltyPoints && dateFormat(loyaltyPoints.updatedAt)}
              </RewardsDate>
              {loyaltyPointsError ? (
                <Error> Error loading loyalty points </Error>
              ) : (
                <>
                  <Points>
                    {loyaltyPoints && numberFormat(loyaltyPoints.available)}
                  </Points>
                  <PointsLabel>Zing Points</PointsLabel>
                  <FinePrint>
                    Every Php 200 spend in participating merchants (look for the
                    Zing decals in-store) earns you 1 point
                  </FinePrint>
                </>
              )}
            </>
          ) : (
            <>
              <BasicDescription>
                Get access to exclusive perks and earn amazing rewards!
              </BasicDescription>
              <BasicDescription>
                Level up your experience by linking your GCash to start earning
                Zing Points.
              </BasicDescription>
              <FinePrint>
                Every Php 200 spend in participating merchants (look for the
                Zing decals in-store) earns you 1 point
              </FinePrint>
            </>
          )}
        </LargeCardContent>
      )}
      {!lite && (
        <RewardsFooter>
          {advanceAccount && advanceAccount.advanced ? (
            <>
              <StyledPointsButton
                variant="primary"
                small
                to="#"
                onClick={showHowToEarn}
              >
                Earn Zing Points
              </StyledPointsButton>
              <Divider>&nbsp;</Divider>
              <StyledPointsButton small to="#" onClick={showPointsHistory}>
                Points History
              </StyledPointsButton>
            </>
          ) : (
            <StyledActionButton
              small
              variant="primary"
              onClick={displayAddCardForm}
            >
              Link card now
            </StyledActionButton>
          )}
        </RewardsFooter>
      )}
    </RewardsSection>
  )
}

PointsCard.defaultProps = {
  // TODO: specify default props
}

PointsCard.propTypes = {
  // TODO: specify prop types
}

export default PointsCard
